export default {
  allSelected: 'All {entity} have been selected.',
}
